import styled from "@emotion/styled";
import {Button} from "@mui/material";
import React, {SyntheticEvent} from "react";
import {observer} from "mobx-react";
import {ReactComponent as GameLogo} from "assets/img/game_logo.svg";
import {useI18n} from "data/hooks";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	min-height: 500px;
`;

const Buttons = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 12px;
	width: 100%;

	button {
		width: 100%;
		font-size: 16px;
		text-transform: capitalize;
	}
`;

const Texts = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 16px;

	.title {
		color: #ffffff;
		text-align: center;
		font-size: 20px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%; /* 28px */
	}

	.text {
		color: #ffffff;
		text-align: center;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 140%; /* 22.4px */
	}
`;

interface IProps {
	onPlay: (e: SyntheticEvent<HTMLButtonElement>) => void;
	onRestart: (e: SyntheticEvent<HTMLButtonElement>) => void;
}

export const ModalTutorialLastStep: React.FC<IProps> = observer(({onRestart, onPlay}) => {
	const i18n = useI18n();
	return (
		<Wrapper>
			<GameLogo />

			<Texts>
				<p className="title">
					{i18n.t("tutorial.last.title", `That's all, you're ready to play!`)}
				</p>

				<p className="text">{i18n.t("tutorial.last.description", `Good luck!`)}</p>
			</Texts>

			<Buttons>
				<Button variant="contained" color="secondary" onClick={onRestart}>
					{i18n.t("tutorial.last.first_button", `Restart Guide`)}
				</Button>
				<Button variant="contained" color="primary" onClick={onPlay}>
					{i18n.t("tutorial.last.second_button", `Play`)}
				</Button>
			</Buttons>
		</Wrapper>
	);
});
